module.exports = __webpack_public_path__ + "img/maisonette-7.c78eeca5.webp";